const statusId = constant => function () {
  return this.$store.state.productOrderStatuses?.find(kv => kv.constant === constant)?.id ?? null
}

export const orderStatuses = {
  computed: {
    inProgressStatusId: statusId('IN_PROGRESS'),
    savedStatusId: statusId('SAVED'),
    scheduledStatusId: statusId('SCHEDULED'),
    submittedStatusId: statusId('SUBMITTED'),
    cancelledStatusId: statusId('CANCELLED')
  }
}
